const initialStates = {
    filterMe: {},
    collapse: false,
}

const mutations = {
    set(state, params) {
        state.filterMe = JSON.parse(JSON.stringify(params))
    },
    push(state, obj) {
        state.filterMe = Object.assign({}, state.filterMe, obj)
    },
    toggleCollapse(state) {
        state.collapse = !state.collapse
    },
    setCollapse(state, collapse) {
        state.collapse = collapse
    }
}

const getters = {
    filterMeFields: state => state.filterMe,
    collapse: state => state.collapse
}

const actions = {
    reset({commit}) {
        commit('set', {})
    },
    setFilterMe({commit}, params) {
        commit('set', params)
    },
    pushAttribute({commit}, obj) {
        commit('push', obj)
    },
    toggleCollapse({commit}) {
        commit('toggleCollapse')
    },
    hideCollapse({commit}) {
        commit('setCollapse', false)
    },
    showCollapse({commit}) {
        commit('setCollapse', true)
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}